import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/clap.svg'


const _withScopeId = n => (_pushScopeId("data-v-4ae27fbd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vertical" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    draggable: "false"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "To bychom měli."),
  /*#__PURE__*/_createElementVNode("div", { class: "description" }, " Žádné zdroje nejsou bezedné. Objevte, jak šetřit vodou s úspornými produkty GROHE. "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "button solidButton",
    href: "?"
  }, "Grohe produkty")
], -1))
const _hoisted_3 = [
  _hoisted_2
]

import { ref } from 'vue'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const isActive = ref(false)

store.subscribe((mutation) => {
  if (mutation.type === 'submit') {
    isActive.value = true
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, null, {
    default: _withCtx(() => [
      (isActive.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})